import React, { useState, useRef, useEffect } from "react";
import ProjectContextMenu from "../ProjectContextMenu/ProjectContextMenu";
import dotsIcon from "../../assets/dots.svg";
import folderBackIcon from "../../assets/folderback.svg";
import starIcon from "../../assets/starIcon.svg";
import eyeIcon from "../../assets/eye.svg";
import { useMenu } from "../../context/MenuContext";
import momentTz from "moment-timezone";
import { useTranslation } from "react-i18next";
import DummyPoster1 from "../../assets/backgrounds/background_1.png";
import DummyPoster2 from "../../assets/backgrounds/background_2.png";
import DummyPoster3 from "../../assets/backgrounds/background_3.png";
import DummyPoster4 from "../../assets/backgrounds/background_4.png";
import DummyPoster5 from "../../assets/backgrounds/background_5.png";
import DummyPoster6 from "../../assets/backgrounds/background_6.svg";
import FolderBack from "../../assets/backgrounds/folderback.svg";
import FolderBackGlow from "../../assets/backgrounds/folderbackglow.svg";
import FolderGlow from "../../assets/backgrounds/folderglow.svg";
import moment from "moment";
import { userRoles } from "../../helpers/constants";
import momentWithLocales from "moment/min/moment-with-locales";
import TeamIcon from "../../assets/teamIcon.svg";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
import { useDispatch, useSelector } from "react-redux";
import {
  currentOrganizationSelector,
  userSelector,
} from "../../store/selectors";
import Avatar from "../Avatar/Avatar";
import UsersPopup from "../VideoPage/UsersPopup";
import { fetchProjectUsers } from "../../store/projectsSlice";
import ShareModal from "../ShareModal/ShareModal";
import BacklogPopup from "../VideoPage/BacklogPopup";
import useIsMobile from "../../hooks/useIsMobile";
import {
  getEffectiveProjectRole,
  isOrgOwner as isUserOrgOwner,
} from "../../helpers/permissions";

const DummyPostersArray = [
  DummyPoster1,
  DummyPoster2,
  DummyPoster3,
  DummyPoster4,
  DummyPoster5,
];

const ProjectPreview = ({
  index,
  isShared,
  isCommenterRole = false,
  isViewerRole = false,
  dropHandlers,
  isDropOver,
  projectInfo: {
    id: projectId,
    title,
    description,
    path,
    teamPreviewList = [],
    posterUrl = null,
    versionsCount = 0,
    subprojectsCount = 0,
    createdDate,
  },
  fetchCurrentProjectById = () => {},
  onClick,
  onDelete,
  onArchive,
  onRestore = () => {},
  onRename,
  onChangeCover,
  isArchive,
}) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const user = useSelector(userSelector);
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isUsersPopupOpen, setUsersPopupOpen] = useState(false);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isBacklogPopupOpen, setBacklogPopupOpen] = useState(false);
  const [projectUsers, setProjectUsers] = useState([]);
  const [isTeamHover, setIsTeamHover] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const { t } = useTranslation();
  const DummyPoster = DummyPostersArray[index % DummyPostersArray.length];
  const hasAccessToProject =
    isUserOrgOwner(user, currentOrganization && currentOrganization.id) ||
    !!getEffectiveProjectRole(user, { id: projectId, path: path || [] });
  const canManageProject = isShared || hasAccessToProject;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showMenu &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        event.stopPropagation();
        event.preventDefault();
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  useEffect(() => {
    if (isUsersPopupOpen) {
      setUsersLoading(true);
      updateProjectUsersList();
    }
  }, [isUsersPopupOpen]);

  const updateProjectUsersList = () => {
    dispatch(fetchProjectUsers(projectId)).then((res) => {
      if (!res.error) {
        let usersArray = res.payload;
        var unique = usersArray.filter(
          (value, index, array) =>
            array.findIndex((val) => val.email === value.email) === index
        );
        setProjectUsers(unique);
        setUsersLoading(false);
      }
    });
  };

  const handleMenuClick = (e) => {
    if (isShared || isCommenterRole || isViewerRole) return;
    e.stopPropagation();
    if (!showMenu && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY + 4, // 4px margin
        left: rect.right + window.scrollX - 224, // align right edge
      });
    }
    setShowMenu(!showMenu);
  };

  const styles = {
    container: {
      width: isMobile ? "100%" : 330,
      height: 220,
      borderRadius: "16px",
      backgroundColor: "#181c24",
      overflow: "visible",
      position: "relative",
      cursor: "pointer",
    },
    imageContainer: {
      width: "99%",
      marginLeft: "0.5%",
      height: "100%",
      position: "relative",
      backgroundColor: "#181c24",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: 16,
      overflow: "hidden",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
      borderRadius: "16px 16px 0 0",
    },
    content: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      gap: 8,
      width: "99%",
      marginLeft: "0.5%",
      height: "100%",
      position: "absolute",
      bottom: isMobile ? -1 : 0,
      zIndex: 2,
    },
    topContent: {
      width: "100%",
      height: 80,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    bottomContent: {
      width: "100%",
      flex: 1,
      padding: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
      boxSizing: "border-box",
      position: "absolute",
      height: 98,
      paddingTop: 8,
    },
    posterBlock: {
      width: "auto",
      height: "100%",
      display: "flex",
      borderRadius: 8,
      overflow: "hidden",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    posterImage: {
      width: isHovered ? "105%" : "100%",
      height: isHovered ? "105%" : "100%",
      objectFit: "cover",
      display: "block",
      borderRadius: "16px 16px 0 0",
      transition: "width 0.2s ease, height 0.2s ease",
    },
    usersBlock: {
      width: "auto",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
    },
    starIconStyle: {
      width: 24,
      height: 24,
    },
    usersBlockList: {
      height: 50,
      width: 100,
    },
    title: {
      color: "#c1c4cb",
      textAlign: "left",
      fontSize: isHovered ? 16 : 14,
      fontWeight: 600,
      fontFamily: "NT Somic, sans-serif",
      margin: 0,
      cursor: "pointer",
      textDecoration: "none",
      transition: "font-size 0.2s ease",
      height: "40px",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      lineHeight: "20px",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    bottomRow: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      height: "24px",
    },
    folderBadge: {
      backgroundColor: "#333b4b",
      borderRadius: "80px",
      padding: "4px 8px",
      color: "#C1C7D4",
      fontSize: 12,
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
      display: "flex",
      alignItems: "center",
    },
    versionBadge: {
      backgroundColor: "#333b4b",
      borderRadius: "80px",
      padding: "4px 8px",
      color: "#C1C7D4",
      fontSize: 12,
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
      display: "flex",
      alignItems: "center",
      marginLeft: 5,
    },
    metaInfo: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      height: "24px",
    },
    timeInfo: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      height: "24px",
    },
    timeText: {
      color: "#717b8e",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
    },
    icon: {
      width: "16px",
      height: "16px",
    },
    menuIcon: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
    loader: {
      width: "40px",
      height: "40px",
      border: "4px solid #333b4b",
      borderTop: "4px solid #4CAF50",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    folderBack: {
      display: "block",
      width: "calc(100% + 2px)",
      marginRight: "-2px",
      height: "100%",
      transformOrigin: "bottom",
      transition: "transform 0.2s ease",
      transform: isHovered ? "scaleY(1.05)" : "scaleY(1)",
      opacity: 1,
      // transform: isHovered ? "scale(1.01, 1.05)" : "scale(1.01, 1)",
    },
    folderBackImage: {
      width: 330,
      height: 220,
    },
  };

  const getVersionsLabel = (count) => {
    return `${+count} ${t("mainScreen.versions")}`;
    return t("mainScreen.versions", { count });
  };

  const getNumberedLocalizedString = (amount, key) => {
    let keyLocalized = `${key}_1`;
    if (amount % 10 === 1) {
      keyLocalized = `${key}_1`;
    } else if (amount % 10 > 1 && amount % 10 < 4) {
      keyLocalized = `${key}_2`;
    } else if (amount % 10 === 0 || amount % 10 > 4) {
      keyLocalized = `${key}_3`;
    }

    return `${amount} ${t(keyLocalized)}`;
  };

  const formatDaysAgo = (date) => {
    const tzMoment = momentTz(date)
      .tz("etc/gmt-6")
      .format("YYYY-MM-DDTHH:mm:ss");
    const uploadedTime = momentWithLocales(tzMoment).locale("ru");

    return uploadedTime.fromNow();
  };

  const handleUpdateTeamMembers = () => {
    dispatch(fetchProjectUsers(projectId)).then((res) => {
      if (!res.error) {
        let usersArray = res.payload;
        var unique = usersArray.filter(
          (value, index, array) =>
            array.findIndex((val) => val.email === value.email) === index
        );
        setProjectUsers(unique);
      }
    });
  };

  const toggleHover = (value) => {
    setIsTeamHover(value);
  };

  return (
    <div
      //style={{ ...styles.container, opacity: isHovered ? 1 : 1 }}
      style={{
        ...styles.container,
        ...(isDropOver
          ? {
              outline: "2px solid #4477ff",
              outlineOffset: 2,
              transform: "scale(1.02)",
            }
          : {}),
        transition: "transform 0.12s ease",
      }}
      {...(dropHandlers || {})}
      onClick={
        isUsersPopupOpen || showShareModal
          ? undefined
          : isArchive
            ? handleMenuClick
            : onClick
      }
      onMouseEnter={(e) => setIsHovered(true)}
      onMouseLeave={(e) => setIsHovered(false)}
    >
      <div style={styles.imageContainer}>
        <img
          src={posterUrl || DummyPoster}
          alt="View"
          style={styles.posterImage}
        />
      </div>
      <div style={styles.content}>
        {/* {isHovered && (
          <div
            style={{
              position: "absolute",
              bottom: 2,
              width: "100%",
              borderRadius: 16,
              overflow: "hidden",
              display: "flex",
            }}
          >
            <img src={FolderGlow} alt="View" style={styles.folderBack} />
          </div>
        )} */}

        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            borderRadius: 16,
            overflow: "hidden",
            display: "flex",
            // transformOrigin: "bottom",
            // transition: "transform 0.2s ease",
            // transform: isHovered ? "scaleY(1.05)" : "scaleY(1)",
          }}
        >
          <img
            src={isHovered ? FolderBack : FolderBack}
            alt="View"
            style={styles.folderBack}
          />
        </div>
        <div style={styles.bottomContent}>
          <h3
            style={{
              ...styles.title,
              cursor: "pointer",
              width: "100%",
              color: isHovered ? "#F1F7FF" : "#C1C7D4",
            }}
            onClick={onClick}
          >
            {title}
          </h3>
          <div style={styles.bottomRow}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                style={{
                  display:
                    isArchive ||
                    isCommenterRole ||
                    isViewerRole ||
                    !canManageProject
                      ? "none"
                      : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 80,
                  padding: "5px 10px",
                  backgroundColor: "#333B4B",
                }}
                onMouseEnter={() => toggleHover(true)}
                onMouseLeave={() => toggleHover(false)}
                onClick={(e) => {
                  if (isShared || isCommenterRole || isViewerRole) return;
                  if (!canManageProject) return;
                  // e.preventDefault();
                  e.stopPropagation();
                  setUsersPopupOpen((v) => !v);
                }}
              >
                <span style={{ color: "#C1C7D4", fontSize: 12 }}>Команда</span>
              </div>
            </div>
            <div style={styles.metaInfo}>
              {isUsersPopupOpen && (
                <UsersPopup
                  usersLoading={usersLoading}
                  projectInfo={{ id: projectId, path: [{ title }] }}
                  organizationId={currentOrganization?.id}
                  isOpen={isUsersPopupOpen}
                  onClose={() => setUsersPopupOpen(false)}
                  usersArray={projectUsers}
                  updateUsersArray={() => handleUpdateTeamMembers()}
                />
              )}

              <div
                style={{
                  ...styles.timeInfo,
                  display: isArchive ? "none" : "flex",
                }}
              >
                <img src={eyeIcon} alt="View" style={styles.icon} />
                <span style={styles.timeText}>
                  {formatDaysAgo(createdDate)}
                </span>
              </div>
              <div
                style={{
                  position: "relative",
                  display: canManageProject ? "flex" : "none",
                  alignItems: "center",
                }}
              >
                <img
                  ref={buttonRef}
                  src={dotsIcon}
                  alt="Menu"
                  style={styles.menuIcon}
                  onMouseOver={(e) => (e.target.style.opacity = "0.8")}
                  onMouseOut={(e) => (e.target.style.opacity = "1")}
                  onClick={handleMenuClick}
                />
                {showMenu && (
                  <ProjectContextMenu
                    ref={menuRef}
                    onArchive={(e) => onArchive(projectId, e)}
                    onRestore={(e) => onRestore(projectId, e)}
                    onOpenShare={(e) => setShowShareModal(true)}
                    isArchive={isArchive}
                    projectId={projectId}
                    posterUrl={posterUrl}
                    onDelete={(e) => onDelete(projectId, e)}
                    onRename={onRename}
                    onChangeCover={onChangeCover}
                    onClose={() => setShowMenu(false)}
                    usePortal={true}
                    style={{
                      position: "absolute",
                      top: menuPosition.top,
                      left: menuPosition.left,
                      zIndex: 2000,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showShareModal && (
        <ShareModal
          isOpen={showShareModal}
          project={{ id: projectId }}
          onClose={() => setShowShareModal(false)}
          handleOpenBacklog={() => setBacklogPopupOpen(true)}
          handleChangeCover={onChangeCover}
          handleRenameProject={onRename}
          handleDeleteProject={(projectId, e) => onDelete(projectId, e)}
          handleArchiveProject={(e) => onArchive(projectId, e)}
        />
      )}
      {isBacklogPopupOpen && (
        <BacklogPopup
          isOpen={isBacklogPopupOpen}
          onClose={() => setBacklogPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default ProjectPreview;
